<template>
    <div class="left">
        <div class="label">商品分类</div>
        <el-tree
            :data="classifyData"
            :props="defaultProps"
            @node-click="handleNodeClick"
            :default-expand-all="true"
            :expand-on-click-node="false"
        ></el-tree>
    </div>
</template>
 
<script>
export default {
    name: "classify",
    props: {
        classifyData: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            defaultProps: {
                children: "children",
                label: "label",
            },
        };
    },

    methods: {
        handleNodeClick(data) {
            this.$emit("handleClassifyChange", data.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.left {
    border: 1px solid #d4d5d6;
    .label {
        height: 30px;
        background: #e9eaea;
        display: flex;
        align-items: center;
        padding-left: 5px;
        color: #333940;
        font-weight: bold;
        font-size: 14px;
    }
}
</style>
